module.exports = __webpack_public_path__ + "static/musee_olympique_stades3-ab17e117f7bb954bce250bff0430d314.png";